import { list49200Sprint07 } from '../ActivityLists/AL49200Sprint07'
import { list49200Sprint08 } from '../ActivityLists/AL49200Sprint08'

import { productPresentation, xyz_8_1of1_PAaA, xyz_8_ClassProductPresentations } from './SL00000Sprint00TTR'

// Software Systems Capstone (SSC) sprint 8 global values.
const sprint = 8
const activityList = () => { return list49200Sprint08(sprint) }
const activityListPrevious = () => { return list49200Sprint07(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

const ssc_8_1of1 = () => { return xyz_8_ClassProductPresentations(xyz_8_1of1_PAaA, null, sprintAndActivityLists, productPresentation) }


export const ssc_8_slidedeckTTR = [ ssc_8_1of1 ]